import axiosFlow from '../axios/axiosFlow'

export default class FaqService {
  static async getTopicos() {
    return axiosFlow.get('faq/topico').then(res => res.data.data)
  }

  static async criarTopico(body) {
    return axiosFlow.post('faq/topico', body)
  }

  static async atualizarTopico(body) {
    return axiosFlow.put('faq/topico', body)
  }

  static async deletarTopico(body) {
    return axiosFlow.delete('faq/topico', body)
  }

  static async criarPerguntaResposta(body) {
    return axiosFlow.post('faq/pergunta-resposta', body)
  }

  static async atualizarPerguntaResposta(body) {
    return axiosFlow.put('faq/pergunta-resposta', body)
  }

  static async deletarPerguntaResposta(body) {
    return axiosFlow.delete('faq/pergunta-resposta', body)
  }
}
